(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-advertorial-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Cards de testimonials: fade-in en orden aleatorio al entrar en viewport
  var cards = document.querySelectorAll('.u1-adv-content__tcard, .u1-adv-content__card');
  if (!cards.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;
  cards.forEach(function (c) { c.classList.add('tcard-hidden'); });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var c = entry.target;
      c.style.setProperty('--tcard-delay', Math.round(Math.random() * 700) + 'ms');
      c.classList.add('tcard-in');
      c.classList.remove('tcard-hidden');
      io.unobserve(c);
    });
  }, { threshold: 0.15 });
  cards.forEach(function (c) { io.observe(c); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-advertorial-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-advo-drag]').forEach(function (el) {
    var down = false, startX = 0, startLeft = 0, moved = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false;
      startX = e.clientX; startLeft = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { moved = true; el.classList.add('is-dragging'); }
      el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      window.setTimeout(function () { el.classList.remove('is-dragging'); }, 50);
    });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
  });

  // Dots de la galeria: uno por slide, sync con el scroll, click navega
  document.querySelectorAll('[data-advo-dots]').forEach(function (dots) {
    var strip = dots.previousElementSibling;
    if (!strip || !strip.hasAttribute('data-advo-drag')) return;
    var frames = strip.children;
    if (frames.length < 2) { dots.style.display = 'none'; return; }
    for (var i = 0; i < frames.length; i++) {
      (function (idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'u1-adv-offer__dot' + (idx === 0 ? ' is-active' : '');
        b.addEventListener('click', function () {
          strip.scrollTo({ left: frames[idx].offsetLeft - strip.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      })(i);
    }
    var sync = function () {
      var idx = Math.round(strip.scrollLeft / strip.clientWidth);
      idx = Math.max(0, Math.min(idx, frames.length - 1));
      for (var j = 0; j < dots.children.length; j++) {
        dots.children[j].classList.toggle('is-active', j === idx);
      }
    };
    strip.addEventListener('scroll', sync, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.u1-collection-grid').forEach(function (root) {
      var scroller = root.querySelector('.u1-collection-grid__scroller');
      var dotsWrap = root.querySelector('[data-u1-cg-dots]');
      if (!scroller || !dotsWrap) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('.u1-collection-grid__card'));
      if (cards.length < 2) return;

      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'u1-collection-grid__dot' + (i === 0 ? ' is-active' : '');
        dot.addEventListener('click', function () {
          scroller.scrollTo({ left: card.offsetLeft - scroller.offsetLeft - 24, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
      var dots = Array.prototype.slice.call(dotsWrap.children);

      var ticking = false;
      function paint() {
        var x = scroller.scrollLeft + scroller.clientWidth * 0.25;
        var idx = 0;
        cards.forEach(function (card, i) { if (card.offsetLeft - cards[0].offsetLeft <= x) idx = i; });
        /* Al fondo del scroll: siempre la ultima */
        if (scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 4) idx = cards.length - 1;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
      scroller.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; paint(); });
      }, { passive: true });
      paint();
    });

    /* ── Modal de comparacion ── */
    document.querySelectorAll('.u1-collection-grid').forEach(function (root) {
      var modal = root.querySelector('[data-u1-cg-compare]');
      var openBtn = root.querySelector('[data-u1-cg-compare-open]');
      if (!modal || !openBtn) return;
      function setOpen(open) {
        modal.hidden = !open;
        document.documentElement.style.overflow = open ? 'hidden' : '';
      }
      openBtn.addEventListener('click', function () { setOpen(true); });
      modal.querySelectorAll('[data-u1-cg-compare-close]').forEach(function (el) {
        el.addEventListener('click', function () { setOpen(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) setOpen(false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-multicolumn"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Cascada: cada columna recibe un delay creciente para el reveal focus-blur
       (el snippet lee data-u1-reveal-delay al momento de animar, asi que basta
       setearlo antes de que la columna entre al viewport). Base 160ms para que
       entre despues del header (0) y el subheadline (120). */
    if (window.__u1McStaggerInit) return;
    window.__u1McStaggerInit = true;
    document.querySelectorAll('[data-u1-mc-track]').forEach(function (track) {
      Array.prototype.forEach.call(track.children, function (col, i) {
        if (!col.hasAttribute('data-u1-reveal-focus-blur') || col.hasAttribute('data-u1-reveal-delay')) return;
        col.setAttribute('data-u1-reveal-delay', String(160 + i * 120));
      });
    });
  })();
  (function () {
    if (window.__u1McCarouselInit) return;
    window.__u1McCarouselInit = true;
    document.querySelectorAll('[data-u1-mc-track]').forEach(function (track) {
      var section = track.closest('section') || track.parentElement;
      if (!section || section.dataset.u1McInit) return;
      var prevBtn = section.querySelector('[data-u1-mc-prev]');
      var nextBtn = section.querySelector('[data-u1-mc-next]');
      if (!prevBtn && !nextBtn) return;
      section.dataset.u1McInit = '1';
      function getGap() { return parseFloat(window.getComputedStyle(track).columnGap) || 20; }
      function step() { var c = track.children[0]; return (c ? c.offsetWidth : 300) + getGap(); }
      function updateArrows() {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
      }
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
      if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-reviews-wall"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root._u1Rw) return;
    root._u1Rw = true;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-u1-rw-card]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-u1-rw-filter]'));
    /* See more: se muestran las primeras N cards (las que pasan el filtro) y el boton suma de a M */
    var filter = '';
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    var mob = !!(mq && mq.matches);
    var initial, step;
    function counts() {
      initial = parseInt(root.getAttribute(mob ? 'data-initial-m' : 'data-initial'), 10) || (mob ? 6 : 12);
      step = parseInt(root.getAttribute(mob ? 'data-step-m' : 'data-step'), 10) || (mob ? 6 : 12);
    }
    counts();
    var moreWrap = root.querySelector('[data-u1-rw-more-wrap]');
    if (!moreWrap) initial = 1e9;
    var limit = initial;
    var moreBtn = root.querySelector('[data-u1-rw-more]');
    function matches(card) {
      var tags = String(card.getAttribute('data-tags') || '').split('|');
      return !filter || tags.indexOf(filter) !== -1;
    }
    /* _rwPulled: cards sumadas por balance() para emparejar columnas; siempre visibles y fuera de la cuenta de See more */
    function apply() {
      var n = 0;
      cards.forEach(function (card) {
        var match = matches(card);
        var pulled = !!card._rwPulled;
        card.hidden = !match || (n >= limit && !pulled);
        if (match && !pulled) n++;
      });
      if (moreWrap) moreWrap.hidden = n <= limit;
    }
    /* Columnas parejas: el reparto a la mas corta puede dejar una columna hasta una card entera mas corta. Si la
       diferencia pasa de 120px se suma a la mas corta, entre las proximas 8 reviews ocultas, la que mejor la empareja */
    function balance(cols) {
      if (!moreWrap || cols.length < 2) return;
      var gap = parseFloat(getComputedStyle(cols[0]).rowGap) || 0;
      function spread(hs) { return Math.max.apply(null, hs) - Math.min.apply(null, hs); }
      for (var guard = 0; guard < 4; guard++) {
        var hs = cols.map(function (c) { return c.offsetHeight; });
        var s0 = spread(hs);
        if (s0 < 120) return;
        var lo = hs.indexOf(Math.min.apply(null, hs));
        var cands = cards.filter(function (c) { return c.hidden && matches(c); }).slice(0, 8);
        if (!cands.length) return;
        cands.forEach(function (c) { c.hidden = false; cols[lo].appendChild(c); });
        var ch = cands.map(function (c) { return c.offsetHeight; });
        cands.forEach(function (c) { c.hidden = true; });
        var best = -1, bs = s0;
        ch.forEach(function (h, i) { var t = hs.slice(); t[lo] += h + gap; var sp = spread(t); if (sp < bs) { bs = sp; best = i; } });
        if (best < 0) return;
        cands[best]._rwPulled = true;
        cands[best].hidden = false;
      }
    }
    apply();
    /* Si cambia de mobile a desktop (o al reves) sin que hayan tocado See more, vuelve a la cantidad inicial que corresponde */
    if (mq && moreWrap) {
      var onMq = function () {
        var untouched = limit === initial;
        mob = mq.matches;
        counts();
        if (untouched) { limit = initial; apply(); layout(true); }
      };
      if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
    }
    /* See more sin rearmar las columnas (eso achicaba la pagina un instante y el navegador saltaba para arriba):
       las cards que aparecen se suman a la columna mas corta y el scroll queda donde estaba */
    if (moreBtn) moreBtn.addEventListener('click', function () {
      var y = window.scrollY;
      var before = cards.filter(function (c) { return !c.hidden; });
      limit += step;
      apply();
      var cols = grid ? Array.prototype.slice.call(grid.querySelectorAll('.u1-rw__col')) : [];
      if (cols.length) {
        var fresh = cards.filter(function (c) { return !c.hidden && before.indexOf(c) === -1; });
        var hs = fresh.map(function (c) { return c.offsetHeight; });
        var gap = parseFloat(getComputedStyle(cols[0]).rowGap) || 0;
        /* Alto de cada columna SIN las cards nuevas: ya se ven donde estaban ocultas y, si no se restan, se cuentan
           dos veces y el reparto deja columnas desparejas */
        var colH = cols.map(function (col) {
          var h = col.offsetHeight;
          fresh.forEach(function (c, i) { if (c.parentNode === col) h -= hs[i] + gap; });
          return h;
        });
        fresh.forEach(function (c, i) {
          var b = 0;
          for (var k = 1; k < cols.length; k++) if (colH[k] < colH[b]) b = k;
          cols[b].appendChild(c);
          colH[b] += hs[i] + gap;
        });
        balance(cols);
      } else {
        layout(true);
      }
      if (Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y);
    });
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-u1-rw-filter') || '';
        chips.forEach(function (c) { var on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        filter = f;
        limit = initial;
        apply();
        layout(true);
      });
    });
    /* Columnas: el puntaje (data-u1-rw-pin) arriba de la columna del centro; las demas cards, en orden, a la mas corta */
    var grid = root.querySelector('.u1-rw__grid');
    var colCount = 0;
    function nCols() { var w = root.clientWidth; var d = parseInt(getComputedStyle(root).getPropertyValue('--rw-cols'), 10) || 3; return w >= 942 ? d : (w >= 552 ? 2 : 1); }
    function layout(force) {
      if (!grid) return;
      var n = nCols();
      if (!force && n === colCount) return;
      colCount = n;
      cards.forEach(function (c) { c._rwPulled = false; });
      apply();
      /* Primero se sacan todas las cards de la grilla: si quedan sueltas al lado de las columnas, les comen el ancho
         y las alturas que se miden para repartir salen mal (las de foto/video miden 0, los textos miden de mas) */
      var frag = document.createDocumentFragment();
      cards.forEach(function (c) { frag.appendChild(c); });
      Array.prototype.forEach.call(grid.querySelectorAll('.u1-rw__col'), function (c) { c.remove(); });
      var cols = [];
      for (var k = 0; k < n; k++) { var c = document.createElement('div'); c.className = 'u1-rw__col'; grid.appendChild(c); cols.push(c); }
      grid.classList.add('is-cols');
      var mid = Math.floor((n - 1) / 2) + (n % 2 === 0 ? 0 : 0);
      if (n === 3) mid = 1;
      /* Todas las cards se miden de una sola vez (en la primera columna: todas tienen el mismo ancho) y despues se
         reparten con esas alturas, sin volver a medir: medir dentro del reparto forzaba un layout por card (1,5 s
         trabado con 70 cards, justo durante la entrada de la portada) */
      var pins = cards.filter(function (c) { return c.hasAttribute('data-u1-rw-pin'); });
      var rest = cards.filter(function (c) { return !c.hasAttribute('data-u1-rw-pin'); });
      pins.forEach(function (c) { cols[mid].appendChild(c); });
      rest.forEach(function (c) { cols[0].appendChild(c); });
      var gap = parseFloat(getComputedStyle(cols[0]).rowGap) || 0;
      var hs = rest.map(function (c) { return c.offsetHeight; });
      var colH = cols.map(function () { return 0; });
      pins.forEach(function (c) { var h = c.offsetHeight; if (h) colH[mid] += h + gap; });
      rest.forEach(function (c, i) {
        var b = 0;
        for (var k = 1; k < cols.length; k++) if (colH[k] < colH[b]) b = k;
        if (b !== 0) cols[b].appendChild(c);
        if (hs[i]) colH[b] += hs[i] + gap;
      });
      balance(cols);
    }
    layout(true);
    if ('ResizeObserver' in window) new ResizeObserver(function () { layout(false); }).observe(root);
    /* Entrada: cada card aparece con fade, blur y una subida corta cuando entra en pantalla; las que entran juntas, escalonadas */
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!still && 'IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
      root.classList.add('is-enter');
      var seen = new IntersectionObserver(function (entries) {
        var k = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.style.setProperty('--rw-d', (k++ * 80) + 'ms');
          en.target.classList.add('is-shown');
          en.target.addEventListener('animationend', function done(ev) { if (ev.target !== en.target) return; en.target.classList.add('is-done'); en.target.removeEventListener('animationend', done); });
          seen.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      cards.forEach(function (c) { seen.observe(c); });
    }
    root.classList.remove('rw-pre');
    Array.prototype.forEach.call(root.querySelectorAll('[data-u1-rw-stat]'), function (stat) {
      var items = Array.prototype.slice.call(stat.querySelectorAll('[data-u1-rw-stat-line]'));
      if (items.length < 2) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var fixed = stat.classList.contains('is-fixed');
      /* Partir numero en caracteres y explicacion en palabras (spans) para la entrada escalonada */
      items.forEach(function (it) {
        var num = it.querySelector('[data-u1-rw-num]');
        var desc = it.querySelector('[data-u1-rw-desc]');
        if (num) { var t = num.textContent; num.setAttribute('aria-label', t); num.textContent = ''; Array.prototype.forEach.call(t, function (ch, k) { var sp = document.createElement('span'); sp.className = 'u1-rw-ch'; sp.setAttribute('aria-hidden', 'true'); sp.style.setProperty('--i', k); sp.textContent = ch; num.appendChild(sp); }); }
        if (desc) { var w = desc.textContent.split(/(\s+)/); desc.textContent = ''; var wi = 0; w.forEach(function (part) { if (!part) return; var sp = document.createElement('span'); sp.className = 'u1-rw-w'; if (/\S/.test(part)) { sp.style.setProperty('--i', wi); wi++; } sp.textContent = part; desc.appendChild(sp); }); }
      });
      /* Numero gigante con tamano variable: si no entra en la card, se achica hasta entrar (y queda centrado) */
      var stage = stat.querySelector('.u1-rw__stat-stage');
      function fit() {
        var avail = stage ? stage.clientWidth : 0;
        if (!avail) return;
        items.forEach(function (it) {
          var num = it.querySelector('[data-u1-rw-num]');
          if (!num) return;
          num.style.fontSize = '';
          var w = num.scrollWidth;
          if (w > avail) num.style.fontSize = (parseFloat(getComputedStyle(num).fontSize) * avail / w * 0.96) + 'px';
        });
      }
      fit();
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(stat);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
      var i = 0, timer = 0, onScreen = true;
      function show(next) {
        var cur = items[i];
        cur.classList.remove('is-on', 'is-in', 'is-settled');
        window.clearTimeout(cur._u1Settle);
        cur.setAttribute('aria-hidden', 'true');
        if (!reduce) { cur.classList.add('is-out'); window.setTimeout(function () { cur.classList.remove('is-out'); }, 450); }
        i = next;
        var el = items[i];
        el.classList.remove('is-out');
        el.removeAttribute('aria-hidden');
        el.classList.add('is-on');
        if (!reduce) {
          void el.offsetWidth;
          el.classList.add('is-in');
          /* Cuando termina la entrada se saca la animacion de cada caracter: en Safari un blur animado a veces
             queda "pegado" en un digito si no se vuelve a pintar */
          window.clearTimeout(el._u1Settle);
          el._u1Settle = window.setTimeout(function () { el.classList.add('is-settled'); }, 1400);
        }
        if (!fixed) { stat.classList.remove('is-c0', 'is-c1', 'is-c2', 'is-c3'); stat.classList.add('is-c' + (i % 4)); }
      }
      function run() { window.clearInterval(timer); timer = 0; if (onScreen && !document.hidden) timer = window.setInterval(function () { show((i + 1) % items.length); }, 4000); }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { onScreen = es[es.length - 1].isIntersecting; run(); }).observe(stat);
      document.addEventListener('visibilitychange', run);
      run();
    });
  }
  /* Videos por streaming (HLS, los de Loox): Safari los reproduce solo; en el resto se carga hls.js (version liviana,
     una sola vez y recien cuando un video esta por aparecer), limitado al tamano de la card */
  var HLS_JS = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.5.13/hls.light.min.js';
  var hlsLoading = null;
  function loadHls() {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (!hlsLoading) hlsLoading = new Promise(function (res, rej) {
      var sc = document.createElement('script');
      sc.src = HLS_JS;
      sc.async = true;
      sc.onload = function () { res(window.Hls); };
      sc.onerror = rej;
      document.head.appendChild(sc);
    });
    return hlsLoading;
  }
  function armHls(v, url) {
    if (v._u1Hls) return;
    v._u1Hls = true;
    var native = function () { v.src = url; v.load(); if (v._u1Want) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } };
    /* hls.js tambien en Safari: asi la calidad se elige una vez, segun la card, y no arranca borrosa */
    loadHls().then(function (Hls) {
      if (!Hls || !Hls.isSupported()) { if (v.canPlayType('application/vnd.apple.mpegurl')) native(); return; }
      var h = new Hls({ startLevel: -1, capLevelToPlayerSize: false, maxBufferLength: 30, backBufferLength: 120 });
      h.on(Hls.Events.MANIFEST_PARSED, function (e, data) {
        /* la calidad que alcanza para el alto de la card en esta pantalla (hasta la mas alta), fija desde el primer cuadro */
        var need = (v.clientHeight || v.getBoundingClientRect().height || 600) * Math.min(window.devicePixelRatio || 1, 2);
        var levels = (data.levels || []).map(function (l, k) { return { k: k, hh: Math.min(l.height || 0, l.width || 0) > 0 ? Math.max(l.height, l.width) : (l.height || 0) }; })
          .sort(function (a, b) { return a.hh - b.hh; });
        if (!levels.length) return;
        var pick = levels.filter(function (l) { return l.hh >= need; })[0] || levels[levels.length - 1];
        h.startLevel = pick.k;
        h.currentLevel = pick.k;
      });
      h.loadSource(url);
      h.attachMedia(v);
      if (v._u1Want) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }).catch(function () { if (v.canPlayType('application/vnd.apple.mpegurl')) native(); });
  }
  /* Reviews en video: UN solo video a la vez, y solo si la card se ve (60%). Corre data-vcycle segundos y pasa al
     siguiente visible (de arriba hacia abajo); con mouse, el que esta bajo el cursor. El archivo se pide recien cuando
     a la card le toca reproducirse. El toggle abre/cierra la review (esa card deja de reproducirse) */
  function initVideos(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-u1-rw-vcard]'));
    if (!cards.length) return;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cycle = Math.max(2, parseFloat(root.getAttribute('data-vcycle')) || 6) * 1000;
    var seen = [], active = null, hovered = null, timer = 0;
    function vid(c) { return c.querySelector('video'); }
    function arm(v) {
      var hs = v.getAttribute('data-hls');
      if (hs) { armHls(v, hs); return; }
      var ds = v.getAttribute('data-src'); if (ds && !v.getAttribute('src')) { v.setAttribute('src', ds); v.load(); }
    }
    function visible() {
      return cards.filter(function (c) { return seen.indexOf(c) !== -1 && !c.hidden && !c.classList.contains('is-open') && vid(c); })
        .sort(function (a, b) { var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return (ra.top - rb.top) || (ra.left - rb.left); });
    }
    function playOnly(card) {
      cards.forEach(function (c) { var v = vid(c); if (v && c !== card) { v._u1Want = false; v.pause(); } });
      active = card;
      if (!card || still) return;
      var v = vid(card);
      if (!v) return;
      arm(v);
      v._u1Want = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(function () { if (!hovered) next(); }, cycle); }
    function next() { var l = visible(); if (!l.length) { playOnly(null); return; } var k = l.indexOf(active); playOnly(l[(k + 1) % l.length]); schedule(); }
    function refresh() {
      if (hovered || root._u1Modal) return;
      if (!active || seen.indexOf(active) === -1 || active.classList.contains('is-open') || active.hidden) { var l = visible(); playOnly(l[0] || null); if (l.length) schedule(); }
    }
    root._u1VRefresh = function () { active = null; refresh(); };
    root._u1VStop = function () { clearTimeout(timer); playOnly(null); };
    function scrollUi(card, panel) {
      var gt = document.createElement('span'); gt.className = 'u1-rw__vgrad u1-rw__vgrad--top'; gt.setAttribute('aria-hidden', 'true');
      var gb = document.createElement('span'); gb.className = 'u1-rw__vgrad u1-rw__vgrad--bottom'; gb.setAttribute('aria-hidden', 'true');
      var bar = document.createElement('span'); bar.className = 'u1-rw__vbar'; bar.setAttribute('aria-hidden', 'true');
      bar.appendChild(document.createElement('i'));
      card.appendChild(gt); card.appendChild(gb); card.appendChild(bar);
      var idle = 0;
      var update = function () {
        var sh = panel.scrollHeight, ch = panel.clientHeight, st = panel.scrollTop;
        var can = sh > ch + 2;
        card.classList.toggle('is-scroll', can);
        card.classList.toggle('is-at-top', st <= 2);
        card.classList.toggle('is-at-bottom', st >= sh - ch - 2);
        if (!can) return;
        var track = bar.clientHeight || 1;
        var th = Math.min(28, track);
        bar.style.setProperty('--vb-h', th + 'px');
        bar.style.setProperty('--vb-y', Math.round((track - th) * st / Math.max(1, sh - ch)) + 'px');
      };
      panel.addEventListener('scroll', function () {
        update();
        card.classList.add('is-scrolling');
        clearTimeout(idle);
        idle = setTimeout(function () { card.classList.remove('is-scrolling'); }, 700);
      }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(panel);
      card._u1ScrollUpdate = update;
    }
    cards.forEach(function (card) {
      var v = vid(card);
      var tog = card.querySelector('[data-u1-rw-tog]');
      var panel = card.querySelector('[data-u1-rw-vreview]');
      if (panel) scrollUi(card, panel);
      if (v) v.muted = true;
      if (v && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        card.addEventListener('mouseenter', function () { if (card.classList.contains('is-open') || root._u1Modal) return; hovered = card; clearTimeout(timer); playOnly(card); });
        card.addEventListener('mouseleave', function () { if (hovered !== card) return; hovered = null; schedule(); });
      }
      if (tog) tog.addEventListener('click', function () {
        var open = card.classList.toggle('is-open');
        card.classList.add('is-touched');
        tog.setAttribute('aria-pressed', open ? 'true' : 'false');
        var tip = tog.getAttribute(open ? 'data-tip-open' : 'data-tip-closed');
        if (tip) { tog.setAttribute('data-tip', tip); tog.setAttribute('aria-label', tip); }
        if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open && panel) { panel.scrollTop = 0; if (card._u1ScrollUpdate) card._u1ScrollUpdate(); }
        if (open) { if (v) v.pause(); if (hovered === card) hovered = null; if (active === card) next(); } else refresh();
      });
      /* card con toggle y sin play (reviews largas con foto, videos sin reproductor): toda la card hace de toggle,
         salvo si se esta seleccionando texto */
      if (tog && !card.querySelector('[data-u1-rw-vplay]')) card.classList.add('is-cardtog');
      if (tog && card.classList.contains('is-cardtog')) card.addEventListener('click', function (e) {
        if (tog.contains(e.target)) return;
        var sel = window.getSelection && String(window.getSelection());
        if (sel) return;
        tog.click();
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var k = seen.indexOf(e.target);
          if (e.isIntersecting && k === -1) seen.push(e.target);
          if (!e.isIntersecting && k !== -1) seen.splice(k, 1);
        });
        refresh();
      }, { threshold: 0.6 });
      cards.forEach(function (c) { io.observe(c); });
    }
  }
  /* Reviews automaticas: Loox (Worker u1-loox-feed) y Videowise (lista publica del widget) se piden en paralelo, se arman
     con los moldes <template> y se intercalan con las cards fijas ANTES de armar las columnas. Si algo no responde en
     5 s, se arma con lo que haya (las cards fijas siempre) */
  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return '';
    try { return d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }); } catch (e) { return ''; }
  }
  function getJSON(url) { return fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function fill(card, sel, text) { Array.prototype.forEach.call(card.querySelectorAll('[data-slot="' + sel + '"]'), function (el) { el.textContent = text || ''; }); }
  function setStars(card, n) {
    Array.prototype.forEach.call(card.querySelectorAll('[data-slot="stars"]'), function (wrap) {
      wrap.setAttribute('aria-label', n + ' / 5');
      Array.prototype.forEach.call(wrap.querySelectorAll('.u1-rw__star'), function (st, k) { st.classList.toggle('is-off', k >= n); });
    });
  }
  /* proporcion ancho/alto de la card: la del medio, entre 9:16 (videos de celular) y 4:5 (lugar para el texto) */
  function setAr(card, ar) { var n = parseFloat(ar); if (!(n > 0)) return; card.style.setProperty('--rw-ar', Math.min(0.8, Math.max(0.5625, n)).toFixed(4)); }
  function fromTpl(root, kind) {
    var t = root.querySelector('template[data-u1-rw-tpl="' + kind + '"]');
    return t ? t.content.firstElementChild.cloneNode(true) : null;
  }
  function openFull(root, opts) {
    if (!window.U1VideoModal) return;
    opts.closeLabel = root.getAttribute('data-l-close') || '';
    window.U1VideoModal.open(opts);
  }
  /* review larga con foto: se muestra solo la foto con nombre y fecha; el gestito abre la review completa (mismo
     panel blanco que las reviews en video) */
  function looxLongCard(root, r) {
    var card = fromTpl(root, 'video');
    if (!card) return null;
    card.classList.add('u1-rw__card--long');
    fill(card, 'name', r.name);
    fill(card, 'date', fmtDate(r.date));
    fill(card, 'text', r.text);
    setStars(card, r.rating || 5);
    setAr(card, r.ar || 0.75);
    var play = card.querySelector('[data-u1-rw-vplay]');
    if (play) play.remove();
    var tg = card.querySelector('[data-slot="tog"]');
    var back = root.getAttribute('data-l-back-photo');
    if (tg && back) tg.setAttribute('data-tip-open', back);
    var im = document.createElement('img');
    im.src = r.photo_hd || r.photo;
    im.alt = r.name || '';
    im.loading = 'lazy';
    im.decoding = 'async';
    im.onerror = function () { if (r.photo_hd && im.src.indexOf(r.photo_hd) !== -1 && r.photo !== r.photo_hd) { im.src = r.photo; return; } im.onerror = null; };
    card.querySelector('[data-slot="media"]').appendChild(im);
    return card;
  }
  /* Entra el texto encima de la foto? Se mide en una card de prueba (fuera de pantalla) con el ancho real de la columna
     y el alto que le da la proporcion de su foto (estrellas + texto, hasta data-loox-space % del alto de la card) */
  function fitGeom(root) {
    var grid = root.querySelector('.u1-rw__grid');
    if (!grid) return null;
    var w = root.clientWidth || grid.clientWidth;
    var d = parseInt(getComputedStyle(root).getPropertyValue('--rw-cols'), 10) || 3;
    var n = w >= 942 ? d : (w >= 552 ? 2 : 1);
    var gap = parseFloat(getComputedStyle(grid).columnGap) || 24;
    return { grid: grid, cw: ((grid.clientWidth || w) - gap * (n - 1)) / n, space: (parseFloat(root.getAttribute('data-loox-space')) || 55) / 100 };
  }
  function fitProbe(root, r, cw) {
    var probe = fromTpl(root, 'review');
    if (!probe) return null;
    probe.classList.add('has-photo', 'is-bg');
    var ph = probe.querySelector('[data-slot="photo"]'); if (ph) ph.remove();
    fill(probe, 'name', r.name);
    fill(probe, 'date', fmtDate(r.date));
    fill(probe, 'text', r.text);
    probe.style.cssText = 'position:absolute;left:0;top:0;aspect-ratio:auto;width:' + cw + 'px';
    return probe;
  }
  function fitNeed(probe) {
    /* solo lo que tapa la foto: estrellas + texto (el nombre y la fecha van siempre, en cualquier formato) */
    var body = probe.querySelector('.u1-rw__body');
    return body ? body.offsetHeight : probe.scrollHeight;
  }
  /* 1) entra en la proporcion de su foto; 2) si no, la card se estira (hasta 9:16) lo justo para que entre;
     3) si ni asi entra, null: va como solo foto + boton */
  function fitFrom(r, need, g) {
    var ar = Math.min(0.8, Math.max(0.5625, parseFloat(r.ar) || 0.75));
    var cw = g.cw, space = g.space;
    if (need <= (cw / ar) * space) return { ar: ar, ratio: need / (cw / ar) };
    var stretched = cw * space / need;
    return stretched >= 0.5625 ? { ar: stretched, ratio: space } : null;
  }
  /* Entra el texto encima de la foto? Se mide en cards de prueba (fuera de pantalla) con el ancho real de la columna.
     Todas las reviews de una vez: un solo layout para todas (de a una, era un layout forzado por review) */
  function measureFits(root, list) {
    var g = fitGeom(root);
    if (!g) return;
    var box = document.createElement('div');
    box.style.cssText = 'position:absolute;left:-10000px;top:0;visibility:hidden;width:' + g.cw + 'px';
    var probes = list.map(function (r) { var p = fitProbe(root, r, g.cw); if (p) box.appendChild(p); return p; });
    g.grid.appendChild(box);
    var needs = probes.map(function (p) { return p ? fitNeed(p) : 0; });
    box.remove();
    list.forEach(function (r, k) { if (probes[k]) r._fit = fitFrom(r, needs[k], g); });
  }
  function textFits(root, r) {
    if (r._fit !== undefined) return r._fit;
    measureFits(root, [r]);
    return r._fit !== undefined ? r._fit : true;
  }
  function looxCard(root, r) {
    var isVideo = r.type === 'video' && r.video;
    var fitAr = null, fitRatio = 0;
    if (!isVideo && r.photo && r.text) {
      var fit = textFits(root, r);
      if (fit === null) return looxLongCard(root, r);
      fitAr = fit.ar;
      fitRatio = fit.ratio;
    }
    var card = fromTpl(root, isVideo ? 'video' : 'review');
    if (!card) return null;
    fill(card, 'name', r.name);
    fill(card, 'date', fmtDate(r.date));
    setAr(card, fitAr || r.ar || (isVideo ? 0.5625 : 0.75));
    fill(card, 'text', r.text);
    setStars(card, r.rating || 5);
    if (isVideo) {
      /* el video de Loox (Cloudflare Stream) corre en la grilla en su version chica por streaming (data-hls) */
      var lv = document.createElement('video');
      lv.muted = true;
      lv.loop = true;
      lv.playsInline = true;
      lv.preload = 'none';
      lv.setAttribute('muted', '');
      lv.setAttribute('playsinline', '');
      lv.poster = r.video.poster || r.photo || '';
      if (r.video.hls) lv.setAttribute('data-hls', r.video.hls);
      card.querySelector('[data-slot="media"]').appendChild(lv);
      if (!r.text) { var tg = card.querySelector('[data-slot="tog"]'); if (tg) tg.remove(); }
      var play = card.querySelector('[data-u1-rw-vplay]');
      play.setAttribute('aria-label', (root.getAttribute('data-l-play') || '') + ' ' + r.name);
      play.addEventListener('click', function () {
        if (root._u1VStop) root._u1VStop();
        root._u1Modal = true;
        openFull(root, { iframe: r.video.iframe, onClose: function () { root._u1Modal = false; if (root._u1VRefresh) root._u1VRefresh(); } });
      });
    } else {
      var ph = card.querySelector('[data-slot="photo"]');
      if (r.photo) {
        /* foto de fondo con el texto encima (el modelo foto arriba / texto abajo no se usa) */
        card.classList.add('has-photo', 'is-bg');
        /* auto: donde no tapa a la persona (lo calcula el Worker con deteccion de personas); si no, el del setting */
        var tpos = root.getAttribute('data-auto-text') || 'auto';
        if (tpos === 'auto') tpos = r.text_pos || 'bottom';
        if (tpos === 'top') card.classList.add('is-text-top');
        /* el degradé cubre lo que ocupa el texto mas un margen: mas texto, mas degradé */
        if (fitRatio) card.style.setProperty('--rw-g', Math.round(Math.min(tpos === 'top' ? 74 : 92, Math.max(tpos === 'top' ? 50 : 60, fitRatio * 100 + 24))) + '%');
        var im = document.createElement('img');
        im.src = r.photo_hd || r.photo;
        /* si la grande no carga, la chica; si tampoco, la card queda de solo texto (nunca un cuadro gris vacio) */
        im.onerror = function () {
          if (r.photo_hd && im.src.indexOf(r.photo_hd) !== -1 && r.photo !== r.photo_hd) { im.src = r.photo; return; }
          im.onerror = null;
          card.classList.remove('has-photo', 'is-bg', 'is-text-top');
          card.style.removeProperty('--rw-ar');
          if (im.parentNode) im.parentNode.remove();
        };
        im.alt = r.name || '';
        im.loading = 'lazy';
        im.decoding = 'async';
        im.width = 600;
        im.height = 600;
        ph.appendChild(im);
      } else ph.remove();
      if (!r.text) { var tx = card.querySelector('[data-slot="text"]'); if (tx) tx.remove(); }
    }
    return card;
  }
  function vwCard(root, v) {
    var card = fromTpl(root, 'video');
    if (!card) return null;
    var who = v.socialProfile && v.socialProfile.userName ? '@' + v.socialProfile.userName : '';
    var clip = v.meta && v.meta.convertedH264 && v.meta.convertedH264.clipUrl;
    var poster = (v.poster && v.poster.url) || (v.thumbnail && v.thumbnail.url) || '';
    fill(card, 'name', who);
    fill(card, 'date', fmtDate(v.createdAt));
    var th = v.thumbnail || {};
    setAr(card, th.width && th.height ? th.width / th.height : (v.orientation === 'LANDSCAPE' ? 1.7778 : 0.5625));
    Array.prototype.forEach.call(card.querySelectorAll('.u1-rw__verified'), function (b) { b.remove(); });
    ['review', 'tog'].forEach(function (k) { var el = card.querySelector('[data-slot="' + k + '"]'); if (el) el.remove(); });
    var vid = document.createElement('video');
    vid.muted = true;
    vid.loop = true;
    vid.playsInline = true;
    vid.preload = 'none';
    vid.setAttribute('muted', '');
    vid.setAttribute('playsinline', '');
    if (poster) vid.poster = poster;
    vid.setAttribute('data-src', v.url || clip);
    card.querySelector('[data-slot="media"]').appendChild(vid);
    var play = card.querySelector('[data-u1-rw-vplay]');
    play.setAttribute('aria-label', (root.getAttribute('data-l-play') || '') + (who ? ' ' + who : ''));
    play.addEventListener('click', function () {
      if (root._u1VStop) root._u1VStop();
      root._u1Modal = true;
      openFull(root, { src: v.url || clip, poster: poster, onClose: function () { root._u1Modal = false; if (root._u1VRefresh) root._u1VRefresh(); } });
    });
    return card;
  }
  function loadAuto(root) {
    var products = root.getAttribute('data-products') || '';
    var jobs = [];
    var looxUrl = root.getAttribute('data-loox');
    if (looxUrl) {
      var q = 'product=' + encodeURIComponent(products) +
        '&min=' + encodeURIComponent(root.getAttribute('data-loox-min') || '5') +
        '&media=' + encodeURIComponent(root.getAttribute('data-loox-media') || 'media') +
        '&limit=' + encodeURIComponent(root.getAttribute('data-loox-limit') || '16') +
        '&lang=' + encodeURIComponent(root.getAttribute('data-locale') || 'en');
      var ex = root.getAttribute('data-loox-exclude');
      if (ex) q += '&exclude=' + encodeURIComponent(ex.replace(/\s+/g, ''));
      jobs.push(getJSON(looxUrl.replace(/\/$/, '') + '/?' + q).then(function (j) { return (j && j.reviews) || []; }).catch(function () { return []; }));
    } else jobs.push(Promise.resolve([]));
    var vw = root.getAttribute('data-vw');
    var vwLimit = parseInt(root.getAttribute('data-vw-limit'), 10) || 0;
    if (vw && vwLimit > 0) {
      var ids = products.split(',').filter(Boolean);
      var mobile = window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      jobs.push(Promise.all(ids.map(function (pid) {
        var u = 'https://api-cdn.videowise.com/widget/bulk.json?widget=' + encodeURIComponent(vw) + '&shop=' + encodeURIComponent(root.getAttribute('data-shop') || '') +
          '&productId=' + encodeURIComponent(pid) + '&device=' + (mobile ? 'MOBILE' : 'DESKTOP') + '&locale=' + encodeURIComponent(root.getAttribute('data-locale') || 'en');
        return getJSON(u).then(function (j) { return (j && j.widgets && j.widgets[0] && j.widgets[0].videos) || []; }).catch(function () { return []; });
      })).then(function (lists) {
        var out = [], seenIds = {};
        for (var i = 0; out.length < vwLimit && lists.some(function (l) { return i < l.length; }); i++) {
          lists.forEach(function (l) { var v = l[i]; var who = v && v.socialProfile && v.socialProfile.userName ? 'u:' + v.socialProfile.userName.toLowerCase() : ''; if (v && out.length < vwLimit && !seenIds[v.id] && !(who && seenIds[who]) && (v.url || (v.meta && v.meta.convertedH264))) { seenIds[v.id] = 1; if (who) seenIds[who] = 1; out.push(v); } });
        }
        return out;
      }));
    } else jobs.push(Promise.resolve([]));
    var timeout = new Promise(function (res) { setTimeout(function () { res(null); }, 5000); });
    return Promise.race([Promise.all(jobs), timeout]).then(function (r) {
      if (!r) return;
      /* sin repetidas: ni la misma review dos veces (Loox puede mostrarla en dos productos), ni una que ya esta como
         card fija (las fijas tambien salieron de Loox): mismo nombre y misma fecha, o mismo nombre y mismo comienzo de texto */
      var norm = function (t) { return String(t || '').toLowerCase().replace(/\s+/g, ' ').trim(); };
      var keys = {};
      Array.prototype.forEach.call(root.querySelectorAll('.u1-rw__grid [data-u1-rw-card]'), function (c) {
        var nm = norm((c.querySelector('.u1-rw__name') || {}).textContent);
        if (!nm) return;
        var dt = norm((c.querySelector('.u1-rw__date') || {}).textContent);
        var tx = norm((c.querySelector('.u1-rw__text') || {}).textContent).slice(0, 40);
        if (dt) keys[nm + '|d|' + dt] = 1;
        if (tx) keys[nm + '|t|' + tx] = 1;
      });
      var ids = {};
      var fresh = r[0].filter(function (x) {
        if (!x || ids[x.id]) return false;
        ids[x.id] = 1;
        var nm = norm(x.name);
        if (keys[nm + '|d|' + norm(fmtDate(x.date))] || keys[nm + '|t|' + norm(x.text).slice(0, 40)]) return false;
        return true;
      });
      measureFits(root, fresh.filter(function (x) { return !(x.type === 'video' && x.video) && x.photo && x.text; }));
      var lx = fresh.map(function (x) { return looxCard(root, x); }).filter(Boolean);
      var vv = r[1].map(function (x) { return vwCard(root, x); }).filter(Boolean);
      /* 2 de Loox, 1 de Videowise */
      var auto = [];
      while (lx.length || vv.length) { if (lx.length) auto.push(lx.shift()); if (lx.length) auto.push(lx.shift()); if (vv.length) auto.push(vv.shift()); }
      if (!auto.length) return;
      var grid = root.querySelector('.u1-rw__grid');
      var fixed = Array.prototype.slice.call(grid.querySelectorAll('[data-u1-rw-card]'));
      /* una fija, dos automaticas, una fija... (las fijas que sobran quedan al final) */
      var order = [];
      var fi = 0;
      while (fi < fixed.length || auto.length) {
        if (fi < fixed.length) order.push(fixed[fi++]);
        if (auto.length) order.push(auto.shift());
        if (auto.length) order.push(auto.shift());
      }
      order.forEach(function (c) { grid.appendChild(c); });
    }).catch(function () {});
  }
  function start(r) {
    if (r._u1RwStart) return;
    r._u1RwStart = true;
    var go = function () { init(r); initVideos(r); };
    if (r.hasAttribute('data-u1-rw-auto')) loadAuto(r).then(go, go); else go();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-u1-rw]'), start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('[data-u1-rw]'); if (r) start(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-u1-sticky-bar]').forEach(function (bar) {
    var after = parseInt(bar.getAttribute('data-show-after'), 10) || 150;
    var anchorId = bar.getAttribute('data-anchor');
    var keepOnFooter = bar.getAttribute('data-keep-on-footer') === '1';
    var footerInView = false;
    var anchorPassed = false;

    // El ancla se resuelve por id, o por data-attribute si alguien puso el nombre a mano
    var anchorEl = null;
    if (anchorId) {
      anchorEl = document.getElementById(anchorId) || document.querySelector('[data-u1-anchor="' + anchorId + '"]');
    }

    var update = function () {
      var scrolled = window.scrollY > (after / 100) * window.innerHeight;
      // Con ancla y scroll configurados gana el primero que se cumpla
      var should = scrolled || anchorPassed;
      bar.classList.toggle('is-visible', should && !(footerInView && !keepOnFooter));
    };

    if (anchorEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting && en.boundingClientRect.top < 0) { anchorPassed = true; }
        });
        update();
      }, { threshold: 0 }).observe(anchorEl);
    }

    // Se retira antes de tapar el footer (legal o del sitio)
    if (!keepOnFooter) {
      var footer = document.querySelector('.u1-legal-footer') || document.querySelector('.u1-footer');
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { footerInView = en.isIntersecting; });
          update();
        }, { rootMargin: '0px 0px -10% 0px' }).observe(footer);
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u1-tabs-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.u1-tabs-menu').forEach(function (menu) {
      var pill = menu.querySelector('.u1-tabs-menu__pill');
      var thumb = menu.querySelector('[data-u1-tabs-menu-thumb]');
      var tabs = Array.prototype.slice.call(menu.querySelectorAll('.u1-tabs-menu__tab'));
      var wrap = menu.closest('.u1-tabs-menu-sticky-wrap') || menu.parentElement;
      var nav = document.querySelector('.u1-navbar[data-u1-navbar]');

      /* ── Thumb deslizante ── */
      function moveThumb(instant) {
        var active = menu.querySelector('.u1-tabs-menu__tab.is-active');
        if (!active || !thumb) return;
        if (instant) thumb.style.transition = 'none';
        thumb.style.width = active.offsetWidth + 'px';
        thumb.style.transform = 'translateX(' + active.offsetLeft + 'px)';
        if (instant) requestAnimationFrame(function () { thumb.style.transition = ''; });
      }
      function setActive(tab) {
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        moveThumb(false);
      }
      window.addEventListener('resize', function () { moveThumb(true); });
      moveThumb(true);

      /* ── Click: activo + scroll suave a anchor ──
         spyLock: mientras viaja el scroll, el scrollspy queda suspendido para
         que el thumb vaya DIRECTO a la tab elegida sin frenar en las intermedias. */
      var spyLockTarget = null;
      var spyLockUntil = 0;
      /* ── Modo filtro: en vez de scrollear, esconde/muestra cards por producto ── */
      var filterTarget = (menu.getAttribute('data-u1-tm-filter-target') || '').trim();
      function applyFilter(tab) {
        var cont = null;
        try { cont = document.querySelector(filterTarget); } catch (_e) { return; }
        if (!cont) return;
        var want = tab.getAttribute('data-u1-tabs-menu-filter') || '';
        cont.querySelectorAll('[data-u1-card-product]').forEach(function (c) {
          c.style.display = (!want || c.getAttribute('data-u1-card-product') === want) ? '' : 'none';
        });
        var track = cont.querySelector('.u1-carousel__track') || cont;
        try { track.scrollTo({ left: 0, behavior: 'smooth' }); } catch (_e2) { try { track.scrollLeft = 0; } catch (_e3) {} }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          setActive(tab);
          if (filterTarget) {
            e.preventDefault();
            applyFilter(tab);
            return;
          }
          if (!tab.hasAttribute('data-u1-tabs-menu-hash')) return;
          var hash = tab.getAttribute('href') || '';
          if (hash.length < 2) return;
          var target = null;
          try { target = document.querySelector(hash); } catch (_e) { return; }
          if (!target) return;
          e.preventDefault();
          var offset = menu.offsetHeight + 16;
          var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
          spyLockTarget = y;
          spyLockUntil = performance.now() + 2000;
          window.scrollTo({ top: y, behavior: 'smooth' });
          if (history.pushState) history.pushState(null, '', hash);
        });
      });

      /* ── Scrollspy: la tab activa sigue a la section visible ── */
      var spyPairs = tabs
        .filter(function (t) { return t.hasAttribute('data-u1-tabs-menu-hash'); })
        .map(function (t) {
          var el = null;
          try { el = document.querySelector(t.getAttribute('href')); } catch (_e) {}
          return el ? { tab: t, el: el } : null;
        })
        .filter(Boolean);

      /* ── Sticky + swap con la nav (mismo patron que el Super menu):
         pegada = tabs visibles y nav oculta, sin importar la direccion;
         la nav solo vuelve al despegarse (de vuelta en el hero). ── */
      function isStuck() {
        return wrap.getBoundingClientRect().top <= 0.5;
      }
      function setNavHidden(hide) {
        if (!nav) return;
        nav.classList.toggle('u1-tm-nav-hidden', hide);
      }
      function updateSpy() {
        if (!spyPairs.length) return;
        if (spyLockTarget !== null) {
          /* Suspendido hasta llegar (o hasta que venza el lock por las dudas) */
          var arrived = Math.abs(window.pageYOffset - spyLockTarget) < 4;
          if (!arrived && performance.now() < spyLockUntil) return;
          spyLockTarget = null;
          if (arrived) return;
        }
        var line = menu.offsetHeight + 24;
        var current = null;
        spyPairs.forEach(function (p) {
          if (p.el.getBoundingClientRect().top <= line) current = p.tab;
        });
        if (current && !current.classList.contains('is-active')) setActive(current);
      }
      /* La nav se esconde ANTES de que las tabs se peguen (zona de despeje);
         las tabs solo existen pegadas: fade-in al stick, fade-out al volver. */
      var NAV_ZONE = 240;
      function update() {
        updateSpy();
        var top = wrap.getBoundingClientRect().top;
        setNavHidden(top <= NAV_ZONE);
        wrap.classList.toggle('u1-tm--stuck', top <= 0.5);
      }

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
